import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export function AdminIndexRedirect() {
  const { isRoot, isAdmin } = useAuthStore();

  if (isRoot()) return <Navigate to="/admin/dashboard" replace />;
  if (isAdmin()) return <Navigate to="/admin/dashboard" replace />;

  return <Navigate to="/dashboard" replace />;
}

